import React from 'react';

import { RecentSignersFeedItem } from './components/RecentSignersFeedItem';
import { useRecentSignersConnection } from './hooks/useRecentSignersConnection';
import { useScrollableFeed } from './hooks/useScrollableFeed';
import { MIN_SIGNERS_TO_SHOW } from './shared/constants';

const DEFAULT_INTERVAL_SECONDS = 3;

export const RecentSignersFeed: React.FC<EmptyProps> = () => {
	const baseRecentSigners = useRecentSignersConnection();
	const scrollerRef = useScrollableFeed(DEFAULT_INTERVAL_SECONDS, baseRecentSigners.length);

	if (baseRecentSigners.length < MIN_SIGNERS_TO_SHOW) {
		return null;
	}

	// Doubling the recent signers to create a seamless scrolling effect.
	const recentSigners = [...baseRecentSigners, ...baseRecentSigners];

	return (
		<div className="relative mb-7">
			<div
				ref={scrollerRef}
				className="flex snap-x snap-proximity flex-row gap-3 overflow-x-hidden scroll-smooth whitespace-nowrap"
			>
				{recentSigners.map((signer, index) => (
					<RecentSignersFeedItem key={`${signer.id}-${index}`} item={signer} />
				))}
			</div>
			<div
				aria-hidden
				className="pointer-events-none absolute top-0 right-0 h-full w-full bg-[linear-gradient(to_right,transparent_80%,var(--color-fill-inverse-strong))]"
			/>
		</div>
	);
};
